import "./SingleBookTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleBookTemplateSection from "./sections/SingleBookTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleBookTemplatePage() {

  return (
    <div>
      <Header />
      <SingleBookTemplateSection />
      <Footer />
    </div>
  )
}
